import Loadable from '../../components/loadable';

const DeleteUserModal = Loadable({
  loader: () => import('../../pages/manage_users/delete_user_modal'),
  type: 'modal',
});

angular.module('shared').value('DeleteUserModal', DeleteUserModal);
